import { Theme, ThemeOptions } from '@mui/material'
import { Colors } from '@chainalysis/design-system/tokens'
import { createTheme } from '@chainalysis/design-system/core'
import type {} from '@chainalysis/design-system/theme/augments'

export const commonThemeOptions: Omit<ThemeOptions, 'typography'> = {
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: ({ theme }) => ({ borderRadius: theme.shape.borderRadius as number }),
      },
      defaultProps: {
        disableUnderline: true,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'text.secondary',
          textDecorationColor: Colors.black.p60,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          '&:last-child': {
            paddingBottom: '12px',
          },
        },
      },
    },
  },
}

const lightTheme: Theme = createTheme('light', commonThemeOptions)

export const darkTheme: Theme = createTheme('dark', commonThemeOptions)

export type ThemeType = 'light' | 'dark'

const themes = new Map<ThemeType, Theme>([
  ['light', lightTheme],
  ['dark', darkTheme],
])

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const getTheme = (themeType: ThemeType): Theme => themes.get(themeType)!
